import * as React from "react";
import Box from "@mui/material/Box";
import LoadingBox from "./LoadingBox";

export default function Loading({ size = 40 }: { size?: number }) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        zIndex:2000,
      }}
    >
      <LoadingBox />
    </Box>
  );
}
